/** Overlay placement in reading order. `start`/`end` follow the document direction (RTL-safe). */
export type LogicalSide = 'top' | 'bottom' | 'start' | 'end';

export function physicalSide(side: LogicalSide): 'top' | 'bottom' | 'left' | 'right' {
  if (side === 'top' || side === 'bottom') return side;
  const rtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
  return (side === 'end') !== rtl ? 'right' : 'left';
}
